export default __webpack_public_path__ + "static/media/smart.ee7148d0.svg";